import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {connectToStores} from 'epic-alt-utils/index';
import {generateRoutePath} from 'epic-common/src/route';
import {SubscriptionStore, LoginStore} from '../../stores';
import {SubscriptionActions} from '../../actions';
import Message from '../../components/message/Message';

/**
 * Success Page.  Shown when user registered.
 *
 */
@connectToStores
export default class Success extends React.Component {
    static propTypes = {
        subscriptionStore: PropTypes.object,
        loginStore: PropTypes.object
    };
    static getInitialActions() {
        return [SubscriptionActions.subscribeEmail];
    }
    static getStores() {
        return [SubscriptionStore, LoginStore];
    }

    static getPropsFromStores() {
        return {
            subscriptionStore: SubscriptionStore.getState(),
            loginStore: LoginStore.getState()
        };
    }
    render() {
        const loginStore = this.props.loginStore || {};
        const subscriptionStore = this.props.subscriptionStore || {};
        const enableNewsLetter = subscriptionStore.enableNewsLetter || false;
        const email = loginStore.accountInfo && loginStore.accountInfo.email;
        const optOutLink = `${subscriptionStore.sailthruOptOutLink}?email=${email}`;

        return (
            <div className="blank-page success-page">
                <div className="description-content">
                    <div className="modal-box">
                        <h2><Message code="epic.battlebreakers.signup.success" /></h2>
                        {
                            enableNewsLetter ?
                                <p className="unsubscribe-desc">
                                    <Message code="epic.battlebreakers.signup.unsubscribe" args={[optOutLink]} />
                                </p>
                                :
                                null
                        }
                        <div className="epicLogo" />
                        <div className="back-home">
                            <span className="home-box">
                                <Link to={generateRoutePath('/home')} >
                                    <span className="home-btn"><Message code="epic.battlebreakers.homepage" /></span>
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
